import React from 'react';
import { Splitter } from './Splitter.js';

function SplitLayoutRenderer({ model }) {
  const { primary, secondary, direction, isHidden, initialSize } = model.useState();
  if (isHidden) {
    return null;
  }
  const Prim = primary.Component;
  const Sec = secondary.Component;
  return /* @__PURE__ */ React.createElement(Splitter, {
    direction,
    initialSize: initialSize != null ? initialSize : 0.5
  }, /* @__PURE__ */ React.createElement(Prim, {
    key: primary.state.key,
    model: primary,
    parentState: model.state
  }), /* @__PURE__ */ React.createElement(Sec, {
    key: secondary.state.key,
    model: secondary,
    parentState: model.state
  }));
}

export { SplitLayoutRenderer };
//# sourceMappingURL=SplitLayoutRenderer.js.map
